module.exports = __webpack_public_path__ + "img/video_wall.83816b09.jpg";